module.exports = __webpack_public_path__ + "img/ring_y_o_1_1@3x.8daa6d7b.png";